import { getCookie, removeCookie, setCookie } from 'react-use-cookie';
import { UTMInterface } from './Interfaces';

export const getUtm = (): Partial<UTMInterface> | null => {
  const utm = getCookie('utm');
  if (!utm) return null;
  return JSON.parse(decodeURIComponent(utm));
};

export const setUtm = (utm: Partial<UTMInterface> | null): void => {
  if (!utm) return removeCookie('utm');
  setCookie('utm', encodeURIComponent(JSON.stringify(utm)));
};
